import $ from 'jquery';

function handleValidationErrors() {

     var errorClass = '.woocommerce-error';
     var targetContainer = '#ffl-checkout-by-ttg-for-woocommerce-errors-destination';
     var sourceContainer = '#ffl-checkout-by-ttg-for-woocommerce-errors-block';
    
    setInterval(function() {

        // Track the current error texts in the source container
        var currentErrors = $(sourceContainer + ' span').map(function() {
            return $(this).text().trim();
        }).get();
    
        // Remove errors from the target container that no longer exist in the source
        $(targetContainer + ' ' + errorClass).each(function() {
            var errorText = $(this).text().trim();
            if (!currentErrors.includes(errorText)) {
                $(this).remove(); // Remove error if it no longer exists in the source
            }
        });
    
        // Add new errors to the target container if they don't exist already
        currentErrors.forEach(function(errorText) {
            if ($(targetContainer + ' ' + errorClass).filter(function() {
                return $(this).text().trim() === errorText;
            }).length === 0) {

                if (errorText.length == 0) {
                    return;
                }

                // Create and append the wrapped div for new errors
                var wrappedDiv = $('<div style="margin:10px 0px;" class="woocommerce-error"></div>').text(errorText);
                $(targetContainer).append(wrappedDiv);
                
            }
        });
    }, 500);
}

export { handleValidationErrors }